export enum IdAmbito {
  Iscrizioni = 'ANAGISCR',
  Mutazioni = 'ANAGMUTAZ',
  Cancellazioni = 'ANAGCANC',
  Stampa = 'ANAGSTAMPA',
}

export const getLabelAmbito = (id: string): string => {
  switch (id) {
    case IdAmbito.Cancellazioni:
      return 'Anagrafe Cancellazione';
    case IdAmbito.Iscrizioni:
      return 'Anagrafe Iscrizione';
    case IdAmbito.Mutazioni:
      return 'Anagrafe Mutazione';
    case IdAmbito.Stampa:
      return 'Anagrafe Altro';
    default:
      return '';
  }
};
